import { AxiosRequestConfig } from 'axios';

import { apiService } from '../../shared/services/apiService';
import { LoadedFile } from '../../shared/interfaces/LoadedFile';
import { ChallengeBannerUploadType } from '../constants/challengeBannerUploadType';

type RequestConfig = Pick<AxiosRequestConfig, 'isRunGlobalSpinner'>;

type BannerRequest = {
  uploadFileId: number;
  uploadType: ChallengeBannerUploadType;
};

export const challengeBannerService = {
  /**
   * Upload banner file to S3
   */
  async uploadBanner(
    type: ChallengeBannerUploadType,
    file: File,
    config?: RequestConfig,
  ): Promise<LoadedFile> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const params = { type };

    const resp = await apiService.post<LoadedFile>(
      'api/challenges/upload-banner',
      formData,
      { params, ...config },
    );

    return resp.data;
  },

  /**
   * Get banner for existing challenge
   */
  async getChallengeBanner(
    challengeId: number,
    type: ChallengeBannerUploadType,
    config?: RequestConfig,
  ): Promise<LoadedFile | undefined> {
    const params = { type };

    const resp = await apiService.get<LoadedFile | undefined>(
      `api/challenges/${challengeId}/banners`,
      { params, ...config },
    );

    return resp.data;
  },

  /**
   * Set banner for existing challenge
   */
  async setChallengeBanner(
    challengeId: number,
    uploadData: BannerRequest,
    config?: RequestConfig,
  ): Promise<LoadedFile> {
    const resp = await apiService.put<LoadedFile>(
      `api/challenges/${challengeId}/banners`,
      uploadData,
      config,
    );

    return resp.data;
  },

  /**
   * Delete banner for existing challenge
   */
  async deleteChallengeBanner(
    challengeId: number,
    deleteData: BannerRequest,
    config?: RequestConfig,
  ): Promise<void> {
    await apiService.delete(`api/challenges/${challengeId}/banners`, {
      data: deleteData,
      ...config,
    });
  },
};
